interface CharCounterProps {
  length: number;
  max: number;
}
export const CharCounter = ({ length, max }: CharCounterProps) => {
  const remaining = max - length;
  const over = remaining < 0;

  const tone = over
    ? 'text-red-600'
    : remaining <= 10
      ? 'text-amber-700'
      : 'text-gray-500';

  return (
    <div className={`mpf-char-counter text-sm ${tone}`}>
      {over && (
        <span className="mpf-char-counter__message" role="alert">
          Excede o limite em {-remaining}{' '}
          {remaining === -1 ? 'caractere' : 'caracteres'}: reduza o texto para
          poder salvar.
        </span>
      )}
      <span className="mpf-char-counter__count font-medium">
        {length}/{max}
      </span>
      <span
        className="mpf-char-counter__remaining font-bold"
        aria-label={
          over ? `${-remaining} acima do limite` : `${remaining} restantes`
        }
      >
        {remaining}
      </span>
    </div>
  );
};

export default CharCounter;
